<template>
  <div class="topLevel">
    <div class="button" :class="{grey: !(match =='start' || match =='plus') || disabled }">
      <div class="staticBackground"></div>
      <div class="background" v-if="(match=='start' || match=='plus') && !disabled"></div>
      <div class="input" :class="{finished: match=='end' || match=='prestart' }" @click="jump">
        {{title}}
        <!-- <div class="tips fs18" :class="{block: !user}" v-if="match=='prestart'">点击按钮刷新复赛状态</div> -->
        <!-- <div class="tips fs18" v-if="state == 'final-end'">金牌附加赛 1月25日上午10:00-10:30</div> -->
      </div>
    </div>
    <p class="tip" v-if="tips">{{tip}}</p>
  </div>
</template>

<script>
export default {
  name: 'TitleButton',
  props: ['state'],
  data () {
    return {
      tip: '',
      tips: false,
      disabled: false,
      startEnroll: false,
    }
  },
  computed: {
    title () {
      if (this.startEnroll) {
        return '信息确认中...'
      }
      if(this.state == 'primary-prestart') {
        return '初赛即将开始'
      }
      if(this.state == 'primary-start')
      {
        return 'AI挑战开始'
      }
      if (this.state == 'enroll-start') {
        return '赛前测试'
      }
      else if(this.state == 'primary-end' || this.state=='final-prestart')
      {
        return '等待复赛'
      }
      else if(this.state == 'repecharge-start')
      {
        return '进入复赛'
      }
      else if(this.state == 'repecharge-end')
      {
        return '决赛即将开始'
      }
      else if(this.state == 'final-start')
      {
        return '进入决赛'
      }
      else if(this.state == 'final-end')
      {
        return '决赛结束'
      }
      else if (this.state =='final-plus')
      {
        return '进入附加赛'
      }
      else if(this.state == 'reward-start')
      {
        return '我的成绩'
      }
    },
    match () {
      return this.state.split('-')[1]
    },
    user() {
      return this.$store.state.auth.user
    },
  },
  watch: {
    state (newv) {
      if (newv=== 'repecharge-start') {
        this.disabled = false
      }
    }
  },
  mounted () {
    if (this.user?.enrolled && this.state === 'enroll-start') {
      this.disabled = true
    }
  },
  methods: {
    jump() {
      if (this.disabled) {
        return
      }
      // {text: '开始比赛', link: {name: 'PlayPage', params: { slug: 'pre'}}},
      if(this.user){
        if (this.state === 'enroll-start') {
          this.disabled = true
          this.startEnroll = true
          this.$http.post('/api/user/enroll', {})
              .then(res => {
                this.tip = '登陆测试成功'
                this.tips=true;
                this.startEnroll = false
                /* this.$store.commit("SUCCESS_ENROLLED");*/
                /* window.location.reload(); */
              }).catch(() => {
                this.disabled = false
              })
        }
        if (this.state === 'repecharge-start') {
          this.$router.push({name: 'PlayPage', params: { slug: 'pre' }})
        }
        if (this.state === 'final-start') {
          this.$router.push({name: 'PlayPageFinal', params: { slug: 'pre' }})
        }
      }
      else
      {
        this.$router.push({name:'account', params:{type:'login'}})
      }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button{
  color: white;
  width: 12.4vw;
  height: 3.5vw;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  background: transparent;
  position: relative;
}
.button.grey{
  overflow: visible;
}
.button>div{
  width: 12.4vw;
  height: 3.5vw;
  position: absolute;
  top: 0;
  left: 0;
}
.button .staticBackground{
  z-index: 1;
  border-radius: 4px;
  background: var(--yellow);
}
.button.grey .staticBackground{
  background: rgba(200,200,200, 0.7);
}
.button .background{
  z-index: 2;
  background: linear-gradient(to right,var(--yellow),var(--orange));
  transition: left 1s linear;
}
.button:hover > .background {
  left: 12.4vw;
  transition: left 1s ease;
}
.button .input{
  display:flex;
  justify-content: center;
  align-items: center;
  font-family: "Andale Mono", AndaleMono, monospace;
  font-size: 1.4vw;
  letter-spacing: 0.2vw;
  z-index: 5;
  position: relative;
}

.tip{
  position: absolute;
  width: 24em;
  text-align:center;
  height: 1.5em;
  color: 'black';
  font-size: 32px;
  bottom: -4.2em;
}
.tips{
  display: none;
  position: absolute;
  width: 24em;
  text-align:center;
  height: 1.5em;
  color: var(--yellow);
  border-radius: 5px;
  top: -1.4em;
  /* background: white; */
}
.display{
  display: block !important;
}
.input.finished:hover > .tips{
  display: block;
}
.block{
  display: none !important;
}

.topLevel{
  font-family: "Andale Mono", AndaleMono, monospace;
  font-size: 1.4vw;
  position: relative;
  display: flex;
  justify-content: center;
  letter-spacing: 0.2vw;
}
</style>
